import React from 'react';
import { FadeIn, Section, SectionLabel, Card } from './UI';
export const ProblemSection = () => {
  return <>
      <Section className="bg-sectionAlt" data-id="element-116">
        <FadeIn data-id="element-117">
          <SectionLabel data-id="element-118">¿Te suena familiar?</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-headline mb-5 font-bold" data-id="element-119">
            Llevas semanas buscando.
            <br data-id="element-120" />
            <span className="text-accent" data-id="element-121">
              Y aún no has dado el primer paso.
            </span>
          </h2>
          <p className="mb-8 text-[1.05rem] text-body" data-id="element-122">
            Has visto videos. Has leído artículos. Has preguntado en grupos. Y
            aun así…
          </p>

          <Card className="p-2 mb-8" data-id="element-123">
            <ul className="divide-y divide-cardBorder" data-id="element-124">
              {['No sabes exactamente por qué pasos empezar ni en qué orden', 'No estás seguro de qué tipo de empresa registrar para tu situación', 'Tienes miedo de cometer un error que te cueste caro: tiempo o dinero', 'Cada respuesta que encuentras genera tres preguntas nuevas', 'Sientes que el proceso es más complicado de lo que debería ser'].map((item, i) => <li key={i} className="py-4 px-4 text-[1.05rem] text-body flex items-start gap-4" data-id="element-125">
                  <span className="text-red-500 font-bold text-[1.1rem] shrink-0 mt-[2px]" data-id="element-126">
                    ✗
                  </span>
                  {item}
                </li>)}
            </ul>
          </Card>

          <Card className="p-8 text-center" data-id="element-127">
            <p className="text-[1.15rem] italic leading-[1.6] text-body" data-id="element-128">
              <strong className="text-accent font-bold" data-id="element-129">
                El problema no es que falte información.
              </strong>
              <br data-id="element-130" />
              El problema es que hay demasiada, y ninguna te la da en orden, con
              los errores reales, para tu situación específica.
            </p>
          </Card>
        </FadeIn>
      </Section>

      <Section className="bg-pageBg" data-id="element-131">
        <FadeIn data-id="element-132">
          <SectionLabel data-id="element-133">Por qué los métodos comunes no funcionan</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-headline mb-5 font-bold" data-id="element-134">
            No es tu culpa que
            <br data-id="element-135" />
            <span className="text-accent" data-id="element-136">sigas paralizado.</span>
          </h2>
          <p className="mb-8 text-[1.05rem] text-body" data-id="element-137">
            Los métodos que la mayoría usa están diseñados para informar, no
            para que ejecutes.
          </p>

          <Card className="overflow-hidden" data-id="element-138">
            <div className="overflow-x-auto" data-id="element-139">
              <table className="w-full border-collapse text-[0.97rem]" data-id="element-140">
                <thead data-id="element-141">
                  <tr className="bg-deepPurple text-white" data-id="element-142">
                    <th className="py-5 px-6 text-left font-semibold" data-id="element-143">
                      Método Común
                    </th>
                    <th className="py-5 px-6 text-left font-semibold" data-id="element-144">
                      Por Qué Falla
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-cardBorder" data-id="element-145">
                  <tr data-id="element-146">
                    <td className="py-4 px-6 text-body" data-id="element-147">🔍 Buscar en Google</td>
                    <td className="py-4 px-6 text-red-500 font-medium" data-id="element-148">
                      Información fragmentada, desactualizada, sin orden y
                      genérica
                    </td>
                  </tr>
                  <tr className="bg-pageBg" data-id="element-149">
                    <td className="py-4 px-6 text-body" data-id="element-150">
                      📺 Videos de YouTube
                    </td>
                    <td className="py-4 px-6 text-red-500 font-medium" data-id="element-151">
                      Sin secuencia, no cubren tu caso, y evitan los errores
                      reales
                    </td>
                  </tr>
                  <tr data-id="element-152">
                    <td className="py-4 px-6 text-body" data-id="element-153">
                      👥 Grupos de Facebook
                    </td>
                    <td className="py-4 px-6 text-red-500 font-medium" data-id="element-154">
                      Opiniones contradictorias de personas que tampoco lo
                      hicieron bien
                    </td>
                  </tr>
                  <tr className="bg-pageBg" data-id="element-155">
                    <td className="py-4 px-6 text-body" data-id="element-156">
                      💸 Contratar sin entender
                    </td>
                    <td className="py-4 px-6 text-red-500 font-medium" data-id="element-157">
                      Gastas sin saber qué compraste ni si lo estás haciendo
                      correcto
                    </td>
                  </tr>
                  <tr className="bg-cardBorder" data-id="element-158">
                    <td className="py-5 px-6 text-headline font-bold" data-id="element-159">
                      ✅ Ruta USA 360
                    </td>
                    <td className="py-5 px-6 text-accent font-bold" data-id="element-160">
                      Proceso completo · En orden · Con los errores que debes
                      evitar
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>
        </FadeIn>
      </Section>
    </>;
};